<template lang="pug">
  .editManagerInputsTable
    BasicInfoInputItem.editManagerInputsTable__item(
      :title="'人員姓名*'"
      :value="managerName"
      :disabled="true")
    BasicInfoInputItem.editManagerInputsTable__item(
      :title="'所屬單位*'"
      :value="managerDepartment"
      :disabled="isEditing === false"
      @input="updateManagerDepartment")
    BasicInfoInputItem.editManagerInputsTable__item(
      :title="'聯絡電話*'"
      :value="managerPhone"
      :disabled="isEditing === false"
      @input="updateManagerPhone")
    BasicInfoInputItem.editManagerInputsTable__item(
      :title="'Email*'"
      :value="managerEmail"
      :disabled="isEditing === false"
      @input="updateManagerEmail")
    PositionSelector.editManagerInputsTable__item(
      :disabled="isEditing === false"
      @change="handlePositionChanged")
    BasicInfoInputItem.editManagerInputsTable__item(
      :title="'客服中心電話*'"
      :value="managerServicePhone"
      :disabled="true")
    BasicInfoInputItem.editManagerInputsTable__item(
      :title="'客服人員編號*'"
      :value="managerServiceNumber"
      :disabled="true")
    BasicInfoInputItem.editManagerInputsTable__item(
      :title="'登入帳號*'"
      :value="managerAccount"
      :disabled="true")
    BasicInfoInputItem.editManagerInputsTable__item(
      :title="'備註*'"
      :value="managerNote"
      :disabled="isEditing === false"
      @input="updateManagerNote")
    .editManagerInputsTable__item.container(v-if="isEditing" v-show="permisionEditManager")
      BaseButton.editManagerInputsTable__button.col-md-2.col-md-offset-2(
        :text="'送出'"
        @click="updateProfile")
      BaseButton.editManagerInputsTable__button.col-md-2(
        :text="'取消'"
        :backgroundColor="'#67c16a'"
        @click="cancelEditing")
    .editManagerInputsTable__item.container(v-else v-show="permisionEditManager")
      BaseButton.editManagerInputsTable__button.col-md-2.col-md-offset-2(
        :text="'編輯'"
        @click="editProfile")
      BaseButton.editManagerInputsTable__button.col-md-2(
        :text="'刪除'"
        :backgroundColor="'#ea999a'"
        @click="deleteManager")
      BaseButton.editManagerInputsTable__button.col-md-2(
        :text="'修改密碼'"
        :backgroundColor="'#ffc107'"
        @click="$emit('openUpdatePasswordModal')")
</template>
<script>
import BasicInfoInputItem from '@/components/common/input/BasicInfoInputItem'
import PositionSelector from '@/pages/manager/PositionSelector'
import BaseButton from '@/components/common/button/BaseButton'
import managerService from '@/API/managerService'
import { mapGetters, mapActions } from 'vuex'
import { getAdminAuthorization } from '../../assets/js/tool/adminAuth'

export default {
  name: 'EditManagerInputsTable',
  data() {
    return {
      loader: null,
      isEditing: false,
    }
  },
  computed: {
    permisionEditManager() {
      return getAdminAuthorization('userManagement') === 2
    },
    ...mapGetters({
      managerAccount: 'managerStore/getSelectedManagerAccount',
      managerDepartment: 'managerStore/getSelectedManagerDepartment',
      managerEmail: 'managerStore/getSelectedManagerEmail',
      managerName: 'managerStore/getSelectedManagerName',
      managerNote: 'managerStore/getSelectedManagerNote',
      managerPhone: 'managerStore/getSelectedManagerPhone',
      managerServiceNumber: 'managerStore/getSelectedManagerServiceNumber',
      managerServicePhone: 'managerStore/getSelectedManagerServicePhone',
      selectedPositionId: 'positionStore/getSelectedPositionId',
    }),
  },
  methods: {
    ...mapActions({
      fetchManagerInfo: 'managerStore/fetchManagerInfo',
      fetchPositionList: 'positionStore/fetchPositionList',
      putSelectedManagerInfo: 'managerStore/putSelectedManagerInfo',
      restoreSelectedManagerInfo: 'managerStore/restoreSelectedManagerInfo',
      setSelectedPositionById: 'positionStore/setSelectedPositionById',
      setSelectedManagerDepartment: 'managerStore/setSelectedManagerDepartment',
      setSelectedManagerPhone: 'managerStore/setSelectedManagerPhone',
      setSelectedManagerPositionId: 'managerStore/setSelectedManagerPositionId',
      setSelectedManagerNote: 'managerStore/setSelectedManagerNote',
      setSelectedManagerEmail: 'managerStore/setSelectedManagerEmail',
    }),
    cancelEditing() {
      this.restoreSelectedManagerInfo()
      this.isEditing = false
    },
    async deleteManager() {
      if (confirm('確認刪除使用者？')) {
        await managerService
          .deleteManager(this.$route.params.id)
          .then(() => {
            alert('刪除成功')
            this.$router.push({ name: 'ManagerList' })
          })
          .catch((err) => {
            alert(`刪除失敗 ${err}`)
          })
      }
    },
    editProfile() {
      this.isEditing = true
    },
    async updateProfile() {
      await this.putSelectedManagerInfo(this.$route.params.id)
        .then(() => {
          alert('更新成功')
          this.isEditing = false
        })
        .catch(() => {
          alert('更新失敗')
        })
    },
    updateManagerDepartment(value) {
      this.setSelectedManagerDepartment(value)
    },
    updateManagerPhone(value) {
      this.setSelectedManagerPhone(value)
    },
    updateManagerEmail(value) {
      this.setSelectedManagerEmail(value)
    },
    updateManagerNote(value) {
      this.setSelectedManagerNote(value)
    },
    handlePositionChanged(id) {
      this.setSelectedPositionById(id)
      this.setSelectedManagerPositionId(id)
    },
    showLoading() {
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
    },
  },
  components: {
    BasicInfoInputItem,
    PositionSelector,
    BaseButton,
  },
  async mounted() {
    await this.showLoading()
    await this.fetchPositionList()
    await this.fetchManagerInfo(this.$route.params.id)
      .then((res) => {
        this.setSelectedPositionById(res.positionId)
        this.loader.hide()
      })
      .catch((e) => {
        console.log(e)
        this.loader.hide()
      })
  },
}
</script>
<style lang="scss" scoped>
.editManagerInputsTable {
  padding: 15px 0;

  &__item {
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
  }

  &__button {
    height: 37px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/EditManagerInputsTable.vue